import dlv from 'dlv';
import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import * as shortcodes from 'remark-shortcodes';
import { ModalClickTrigger, ModalScrollTrigger, ModalTimerTrigger, } from '../modals';
import slugify from '../utils/slugify';
import Banner from './Banner';
import Cta from './Cta';
import MarkdownImage from './Image';
import YoutubeVideo from './YoutubeVideo';
export const markdownShortcodeMap = {
    youtube: YoutubeVideo,
    cta: Cta,
    banner: Banner,
    modal_click_trigger: ModalClickTrigger,
    modal_timer_trigger: ModalTimerTrigger,
    modal_scroll_trigger: ModalScrollTrigger,
};
function ShortcodeRenderer(props) {
    const { identifier, attributes } = props;
    const Component = markdownShortcodeMap[identifier];
    return React.createElement(Component, Object.assign({}, attributes));
}
export const defaultRenderers = {
    image: MarkdownImage,
    paragraph: (props) => {
        const key = dlv(props, 'children.0.key', '');
        const { children } = props;
        if (key.startsWith('image')) {
            return children;
        }
        return React.createElement("p", null, children);
    },
    heading: ({ level, children }) => {
        const H = `h${level}`;
        const value = dlv(children, '0.props.value');
        if (!value) {
            return React.createElement(H, null, children);
        }
        const slug = slugify(value);
        return (React.createElement(H, null,
            React.createElement("a", { id: slug, title: value }, children)));
    },
};
const renderers = {
    shortcode: ShortcodeRenderer,
    ...defaultRenderers,
};
function Markdown({ source }) {
    return (React.createElement(ReactMarkdown, { source: source || '', plugins: [shortcodes], renderers: renderers, escapeHtml: false }));
}
export default Markdown;
//# sourceMappingURL=index.js.map